import {Reservation} from "../../models/Reservation";

const PHONE_BALEARES = '871575544';
const PHONE_PENINSULA = '966754497';

// Texto del SMS de cita. Lo usan las tres pantallas que lo envían (confirmación,
// página de confirmación y "mi reserva"), para que no puedan divergir.
export function buildReservationSms(reservation: Reservation): string {
  const [year, month, day] = String(reservation.date).substring(0, 10).split('-');
  const shortDate = `${day}/${month}/${year.slice(-2)}`;
  const phone = reservation.station?.state?.name === 'Islas Baleares' ? PHONE_BALEARES : PHONE_PENINSULA;

  return `El vehículo con matrícula ${reservation.registration_number} tiene cita el ${shortDate} a las ${reservation.hour.hour} en ${reservation.station.name}. Anular o gestionar: cita.somositv.com o ${phone}`;
}
